export default __webpack_public_path__ + "static/media/32-min.43a198b6.jpg";